import { plainToClass } from 'class-transformer';
import {
  API_PROFIT_CENTER_FIND_ALL,
  API_PROFIT_CENTER_FIND_ONE,
  API_PROFIT_CENTER_UPDATE,
  API_PROFIT_CENTER_CREATE,
  API_PROFIT_CENTER_DELETE
} from '../api.routes';
import { BaseApi } from './base.api';
import { ProfitCenterDto } from '../dto';
import { FindAllResponse } from '../types';

export class ProfitCenterApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<ProfitCenterDto>> {
    return this.httpClient
      .get(API_PROFIT_CENTER_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(ProfitCenterDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<ProfitCenterDto> {
    return this.httpClient
      .get(API_PROFIT_CENTER_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(ProfitCenterDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<ProfitCenterDto> {
    return this.httpClient
      .post(API_PROFIT_CENTER_CREATE, data)
      .then(({ data }) => {
        return plainToClass(ProfitCenterDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<ProfitCenterDto> {
    return this.httpClient
      .put(API_PROFIT_CENTER_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(ProfitCenterDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_PROFIT_CENTER_DELETE, {
      pathParams: { uuid }
    });
  }
}
